import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewTabs } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DSIFeatures.module.css";
import { DSIFlags, DSIPackages, DSIProductTour, DSIFeatureFlags } from "..";

export default function DSIFeatures({ companies }) {
	const navigate = useNavigate();
	const { tab, subTab } = useParams();
	const [selectedTab, setSelectedTab] = useState(0);
	const tabs = useMemo(
		() => [
			{
				label: translate("dsi.tab.tooltip.feature-flag-management"),
				param: "feature-flag",
				component: <DSIFeatureFlags />,
			},
			{ label: translate("dsi.tab.tooltip.flag-management"), param: "flag", component: <DSIFlags /> },
			{
				label: translate("dsi.tab.tooltip.package-management"),
				param: "package",
				component: <DSIPackages platformCompanies={companies} />,
			},
			{
				label: translate("dsi.tab.tooltip.product-tour-management"),
				param: "product-tour",
				component: <DSIProductTour companies={companies} />,
			},
		],
		[companies]
	);
	useEffect(() => {
		if (subTab) {
			const index = tabs.findIndex((t) => t.param === subTab);
			if (index >= 0) {
				setSelectedTab(index);
			}
		}
	}, [tabs, subTab]);

	const handleChangeSelectedTab = (_, newTab) => {
		const { param } = tabs[newTab];
		setSelectedTab(newTab);
		if (tab && param) {
			navigate(`/dsi/${tab}/${param}`, { replace: true });
		}
	};

	return (
		<div className={styles.main}>
			<div className={styles.header}>
				<div className={styles.tabs}>
					<ViewTabs
						noPadding
						noShadow
						selectedTab={selectedTab}
						tabClassName={styles.tab}
						tabs={tabs}
						onChange={handleChangeSelectedTab}
					/>
				</div>
			</div>
			{tabs[selectedTab].component}
		</div>
	);
}
